export * from './ng4-files.module';
export * from './services';
export * from './declarations';



// WEBPACK FOOTER //
// ./src/app/shelf/Clouddata/ng4-files/index.ts